import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type VariantsInfo as SchemaVariantsInfo } from '../schemas/VariantsInfo';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetVariantsInfoContentType = '' as const;
export type GetVariantsInfoRequest = undefined;
export type GetVariantsInfoResponses = LinkCommonErrorResponses & {
    /**
     * @description Variants info
     */
    '200': {
        'application/json': SchemaVariantsInfo;
    };
};
export type GetVariantsInfoResponseSuccess = GetVariantsInfoResponses['200']['application/json'];
export type GetVariantsInfoSearchParams = {
    signature: string;
    original_variant_id: string;
    variant_id?: string;
    selected_characteristic_id?: string;
    selected_characteristic_value?: string;
    delivery_chunk_id: number;
};
export type GetVariantsInfoPathParameters = {
    store_slug: string;
    order_id: string;
};
export const GetVariantsInfoUrl = '/{store_slug}/variants_info/{order_id}' as const;
export const GetVariantsInfoMethod = 'GET' as const;
export const getGetVariantsInfoUrl = (params: GetVariantsInfoPathParameters) =>
    GetVariantsInfoUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetVariantsInfoPathParameters) =>
        String(params[param])
    );
